import { Sorter as SorterRoot } from './components/Sorter';
import { CreateElement } from './components/CreateElement';
import { MoveElement } from './components/MoveElement';
import { SorterContainer } from './components/SorterContainer';
export var Sorter = Object.assign(SorterRoot, {
  Create: CreateElement,
  Move: MoveElement,
  Container: SorterContainer
});